import React, { useState } from 'react';
import { API_URL } from '../../config/api';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess(false);

    try {
      const response = await fetch(`${API_URL}/auth/forgot-password.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });

      const data = await response.json();

      if (data.success) {
        setSuccess(true);
        setEmail('');
      } else {
        setError(data.message || 'Virhe pyynnön käsittelyssä');
      }
    } catch (err) {
      setError('Verkkovirhe. Yritä uudelleen.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)',
      padding: '1rem'
    }}>
      <div style={{
        width: '100%',
        maxWidth: '440px',
        background: '#1e293b',
        borderRadius: '24px',
        padding: '2.5rem',
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
        animation: 'slideUp 0.5s ease-out'
      }}>
        {/* OneTrack Logo */}
        <div style={{
          width: '64px',
          height: '64px',
          background: '#FFEB3B',
          borderRadius: '16px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 1.5rem',
          padding: '8px'
        }}>
          <img
            src="/taskmanager/onetrack192.png"
            alt="OneTrack"
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain'
            }}
          />
        </div>

        <h2 style={{
          fontSize: '28px',
          fontWeight: '700',
          textAlign: 'center',
          marginBottom: '0.5rem',
          color: '#ffffff'
        }}>Unohtuiko salasana?</h2>

        <p style={{
          textAlign: 'center',
          color: '#94a3b8',
          marginBottom: '2rem',
          fontSize: '14px'
        }}>
          Syötä sähköpostiosoitteesi, niin lähetämme sinulle ohjeet salasanan palauttamiseen.
        </p>

        {success ? (
          <div>
            <div style={{
              padding: '1rem',
              background: 'rgba(34, 197, 94, 0.1)',
              border: '2px solid #22c55e',
              borderRadius: '12px',
              color: '#22c55e',
              fontSize: '14px',
              marginBottom: '1.5rem',
              textAlign: 'center'
            }}>
              ✓ Ohjeet lähetetty! Tarkista sähköpostisi.
            </div>

            <a
              href="/taskmanager/"
              style={{
                display: 'block',
                width: '100%',
                padding: '0.875rem',
                background: '#FFEB3B',
                color: '#0f172a',
                border: 'none',
                borderRadius: '12px',
                fontSize: '16px',
                fontWeight: '600',
                textAlign: 'center',
                textDecoration: 'none',
                transition: 'transform 0.2s'
              }}
              onMouseOver={(e) => e.target.style.transform = 'translateY(-2px)'}
              onMouseOut={(e) => e.target.style.transform = 'translateY(0)'}
            >
              Takaisin kirjautumiseen
            </a>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: '1.5rem' }}>
              <label style={{
                display: 'block',
                marginBottom: '0.5rem',
                fontSize: '14px',
                fontWeight: '500',
                color: '#ffffff'
              }}>
                Sähköpostiosoite
              </label>
              <input
                type="email"
                placeholder="matti@example.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                style={{
                  width: '100%',
                  padding: '0.875rem 1rem',
                  background: '#0f172a',
                  border: '2px solid #334155',
                  borderRadius: '12px',
                  fontSize: '15px',
                  outline: 'none',
                  color: '#ffffff'
                }}
                required
              />
            </div>

            {error && (
              <div style={{
                padding: '0.875rem',
                background: '#ef4444',
                border: '1px solid #ef4444',
                borderRadius: '12px',
                color: '#ffffff',
                fontSize: '14px',
                marginBottom: '1rem'
              }}>
                {error}
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              style={{
                width: '100%',
                padding: '0.875rem',
                background: loading ? '#64748b' : '#FFEB3B',
                color: loading ? '#ffffff' : '#0f172a',
                border: 'none',
                borderRadius: '12px',
                fontSize: '16px',
                fontWeight: '600',
                cursor: loading ? 'not-allowed' : 'pointer',
                transition: 'transform 0.2s',
                marginBottom: '1rem'
              }}
              onMouseOver={(e) => !loading && (e.target.style.transform = 'translateY(-2px)')}
              onMouseOut={(e) => e.target.style.transform = 'translateY(0)'}
            >
              {loading ? 'Lähetetään...' : 'Lähetä palautuslinkki'}
            </button>

            <a
              href="/taskmanager/"
              style={{
                display: 'block',
                textAlign: 'center',
                color: '#94a3b8',
                fontSize: '14px',
                textDecoration: 'none'
              }}
              onMouseOver={(e) => e.target.style.textDecoration = 'underline'}
              onMouseOut={(e) => e.target.style.textDecoration = 'none'}
            >
              ← Takaisin kirjautumiseen
            </a>
          </form>
        )}
      </div>

      <style>{`
        @keyframes slideUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </div>
  );
}

export default ForgotPassword;
